module.exports = "<h1>Page not found</h1>"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/_components/page-not-found/page-not-found.component.html
// module chunks = main